import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { HiOutlineTemplate } from "react-icons/hi";
import TooltipConfig from "../../../../components/Tooltip";
import { HomeContext } from "../../../../contexts/Home/HomeContext";
import AddNewPage from "../AddNewPage";
import TemplatesGrid from "../TemplatesGrid";
import { Dashboard } from "../../../../contexts/Dashboard/DashboardContext";
import "../styles.css";
import { IoHelpCircleOutline } from "react-icons/io5";

function MouseOver(event: BaseSyntheticEvent) {
  event.target.style.cursor = "pointer";
}
const AddNewPageModal = (props: { show: boolean; onHide: () => void }) => {
  const [showTemplates, setShowTemplates] = useState(false);
  const [isvalid, setIsvalid] = useState(false);
  const [importCode, setImportCode] = useState<string>("");
  const { ImportDashboard } = useContext(HomeContext);

  const handleImport = (event: { target: { value: string } }) => {
    const newValue = event.target.value;
    setImportCode(newValue);
  };

  useEffect(() => {
    validadeJSON(importCode);
  }, [importCode]);

  const ImportDashboardButton = () => {
    ImportDashboard(JSON.parse(importCode));
  };

  function validadeJSON(importCode: string) {
    try {
      const jsonDasboard = JSON.parse(importCode);
      if (
        !Object.prototype.hasOwnProperty.call(jsonDasboard, "title") ||
        typeof jsonDasboard.title !== "string" ||
        (Object.prototype.hasOwnProperty.call(jsonDasboard, "id") &&
          typeof jsonDasboard.id !== "string") ||
        (Object.prototype.hasOwnProperty.call(jsonDasboard, "filters") &&
          (typeof jsonDasboard.filters !== "object" ||
            !Array.isArray(jsonDasboard.filters.regions) ||
            !Array.isArray(jsonDasboard.filters.shippers) ||
            !Array.isArray(jsonDasboard.filters.couriers) ||
            !Array.isArray(jsonDasboard.filters.clients) ||
            !Array.isArray(jsonDasboard.filters.routeTypes))) ||
        !Array.isArray(jsonDasboard.graphics)
      ) {
        setIsvalid(false);
      }
      setIsvalid(
        jsonDasboard.graphics.every((item: Dashboard["graphics"][0]) => {
          return (
            typeof item.h === "number" &&
            typeof item.i === "string" &&
            typeof item.w === "number" &&
            typeof item.x === "number" &&
            typeof item.y === "number" &&
            typeof item.moved === "boolean" &&
            typeof item.static === "boolean"
          );
        })
      );
    } catch (error) {
      setIsvalid(false);
    }
  }

  return (
    <Modal
      onHide={() => {
        setShowTemplates(false);
        props.onHide();
      }}
      show={props.show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => setShowTemplates(false)}
        id="header-modal"
      >
        <Modal.Title id="contained-modal-title-vcenter">
          {showTemplates === false ? (
            <>Adicionar nova página</>
          ) : (
            <>Templates</>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body id="body-modal">
        {showTemplates === false ? (
          <>
            <Row className="d-flex justify-content-center">
              <Col style={{ maxWidth: "340px" }}>
                <AddNewPage
                  modal={false}
                  description={
                    "Crie uma página em branco com gráficos que desejar"
                  }
                />
              </Col>
              <Col style={{ maxWidth: "340px" }}>
                <div
                  className="user-page"
                  onMouseOver={MouseOver}
                  onClick={() => setShowTemplates(true)}
                >
                  <div className="user-page-div">
                    <div id="user-page-title">
                      <h4>Templates</h4>
                    </div>
                    <div style={{ padding: "15px" }}>
                      <TooltipConfig
                        content={["Buscar template"]}
                        children={<HiOutlineTemplate size={70} />}
                        placement={"bottom"}
                        style={true}
                      />
                    </div>
                    <div id="user-page-description">
                      Adicione um template pronto a uma página
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center pt-4">
              <Col style={{ maxWidth: "680px" }}>
                <div
                  className="user-page"
                  onMouseOver={MouseOver}
                  id="card-import"
                >
                  <div className="user-page-div">
                    <div
                      id="user-page-title"
                      className="display-flex-space-around row align-itens-center"
                    >
                      <div className="col-1"></div>
                      <h4 className="col-10">Importar</h4>
                      <a
                        href="https://comprovei-ct6.movidesk.com/kb/article/417494/tle-veja-como-duplicar"
                        target="_blank"
                        className="col-1 text_theme"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center"}}
                      >
                        <TooltipConfig
                          content={["Ajuda"]}
                          children={
                            <IoHelpCircleOutline
                              onMouseOver={MouseOver}
                              size={20}
                            />
                          }
                          placement={"top"}
                          style={true}
                        />
                      </a>
                    </div>
                    <div style={{ margin: "10px 0px" }}>
                      <div className="input-border-import">
                        <input
                          type="text"
                          placeholder="Código da página"
                          value={importCode}
                          onChange={handleImport}
                          className="input-import"
                        />
                        <TooltipConfig
                          content={[
                            "Para importar é necessário ter exportado alguma página criada",
                          ]}
                          children={
                            <button
                              disabled={!isvalid}
                              onClick={ImportDashboardButton}
                              className="buttom-import"
                              style={{
                                backgroundColor: !isvalid
                                  ? "#6B8096"
                                  : "#3087acff",
                              }}
                            >
                              Importar
                            </button>
                          }
                          placement={"top"}
                          style={true}
                        />
                      </div>
                      {!isvalid && importCode.length > 0 ? (
                        <span style={{ fontSize: "10px", width: "100px" }}>
                          Insira um código valido
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div id="user-page-description">
                      Adicione um codígo de página pronto a uma nova página
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <TemplatesGrid />
        )}
      </Modal.Body>
      <Modal.Footer>
        {showTemplates === false ? (
          <Button onClick={props.onHide}>Fechar</Button>
        ) : (
          <Button onClick={() => setShowTemplates(false)}>Voltar</Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
export default AddNewPageModal;
